module.exports = require("redis");